import { render } from "./UploaderDataList.component.vue?vue&type=template&id=1d6b3381&scoped=true&ts=true"
import script from "./UploaderDataList.component.vue?vue&type=script&lang=ts"
export * from "./UploaderDataList.component.vue?vue&type=script&lang=ts"

import "./UploaderDataList.component.vue?vue&type=style&index=0&id=1d6b3381&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6b3381"]])

export default __exports__